import css from './ThinkingDots.module.css';

/**
 * Words on their way, as the old kiosk wrote them (frontend ChatLog.tsx): three «•» in the text's own
 * font, size and line, so they sit exactly where the first word will start, and a bubble holding them
 * is one line tall. Every chat draws these; `label` names them for a screen reader where they are the
 * only thing said.
 */
export function ThinkingDots({ label }: { label?: string }) {
  return (
    <span className={css.dots} role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <i>•</i><i>•</i><i>•</i>
    </span>
  );
}
